export default __webpack_public_path__ + "static/media/allpatients_arrow_icon.2288695e.svg";